var _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuiltForStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "#09090D",
    stroke: "#15192C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3022,
    cy: 61.1376,
    r: 10,
    transform: "rotate(43.7105 39.3022 61.1376)",
    fill: "#3913D2",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0159,
    cy: 30.001,
    r: 19.5,
    transform: "rotate(43.7105 40.0159 30.001)",
    fill: "#3913D2",
    stroke: "#15192C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7386,
    cy: 49.104,
    r: 15,
    transform: "rotate(43.7105 39.7386 49.104)",
    fill: "#3913D2",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltForStart);
export default __webpack_public_path__ + "static/media/builtForStart.5bd03569.svg";
export { ForwardRef as ReactComponent };